// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApitypesEnvironmentsCostsResponse,
  ApitypesEnvironmentsCostsSummaryResponse,
  ApitypesUpsertEnvironmentCostRequest,
  ApitypesUpsertEnvironmentsCostsRequest,
  ApitypesUpsertEnvironmentsMetadataRequest,
} from '../models/index';
import {
  ApitypesEnvironmentsCostsResponseFromJSON,
  ApitypesEnvironmentsCostsResponseToJSON,
  ApitypesEnvironmentsCostsSummaryResponseFromJSON,
  ApitypesEnvironmentsCostsSummaryResponseToJSON,
  ApitypesUpsertEnvironmentCostRequestFromJSON,
  ApitypesUpsertEnvironmentCostRequestToJSON,
  ApitypesUpsertEnvironmentsCostsRequestFromJSON,
  ApitypesUpsertEnvironmentsCostsRequestToJSON,
  ApitypesUpsertEnvironmentsMetadataRequestFromJSON,
  ApitypesUpsertEnvironmentsMetadataRequestToJSON,
} from '../models/index';

export interface EnvironmentsEnvironmentIDDeleteRequest {
  environmentID: string;
}

export interface EnvironmentsEnvironmentIDPostRequest {
  environmentID: string;
  request: ApitypesUpsertEnvironmentCostRequest;
}

export interface EnvironmentsGetRequest {
  startDate?: string;
  endDate?: string;
  environmentID?: string;
}

export interface EnvironmentsMetadataPostRequest {
  request: Array<ApitypesUpsertEnvironmentsMetadataRequest>;
}

export interface EnvironmentsPostRequest {
  request: Array<ApitypesUpsertEnvironmentsCostsRequest>;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
  /**
   * Delete all cost records for an environment
   * Delete an environment cost
   */
  async environmentsEnvironmentIDDeleteRaw(
    requestParameters: EnvironmentsEnvironmentIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling environmentsEnvironmentIDDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/environments/{environmentID}`;
    urlPath = urlPath.replace(
      `{${'environmentID'}}`,
      encodeURIComponent(String(requestParameters['environmentID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Delete all cost records for an environment
   * Delete an environment cost
   */
  async environmentsEnvironmentIDDelete(
    requestParameters: EnvironmentsEnvironmentIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.environmentsEnvironmentIDDeleteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Upsert an environment cost for a specific cloud service
   * Upsert an environment cost
   */
  async environmentsEnvironmentIDPostRaw(
    requestParameters: EnvironmentsEnvironmentIDPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling environmentsEnvironmentIDPost().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling environmentsEnvironmentIDPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/environments/{environmentID}`;
    urlPath = urlPath.replace(
      `{${'environmentID'}}`,
      encodeURIComponent(String(requestParameters['environmentID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApitypesUpsertEnvironmentCostRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Upsert an environment cost for a specific cloud service
   * Upsert an environment cost
   */
  async environmentsEnvironmentIDPost(
    requestParameters: EnvironmentsEnvironmentIDPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.environmentsEnvironmentIDPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Download all-time daily cost totals per environment as CSV. One row per environment per day. Missing name or owner is an empty cell. Does not include cloud provider or service breakdown.
   * Export total daily environment costs as csv
   */
  async environmentsExportGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/environments/export`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Download all-time daily cost totals per environment as CSV. One row per environment per day. Missing name or owner is an empty cell. Does not include cloud provider or service breakdown.
   * Export total daily environment costs as csv
   */
  async environmentsExportGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Blob> {
    const response = await this.environmentsExportGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get summarised cloud costs of environments per service per day for a given date range.
   * Get summary of environments costs
   */
  async environmentsGetRaw(
    requestParameters: EnvironmentsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApitypesEnvironmentsCostsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['startDate'] != null) {
      queryParameters['startDate'] = requestParameters['startDate'];
    }

    if (requestParameters['endDate'] != null) {
      queryParameters['endDate'] = requestParameters['endDate'];
    }

    if (requestParameters['environmentID'] != null) {
      queryParameters['environmentID'] = requestParameters['environmentID'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/environments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ApitypesEnvironmentsCostsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Get summarised cloud costs of environments per service per day for a given date range.
   * Get summary of environments costs
   */
  async environmentsGet(
    requestParameters: EnvironmentsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApitypesEnvironmentsCostsResponse> {
    const response = await this.environmentsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Upsert environments metadata records
   * Upsert environments metadata
   */
  async environmentsMetadataPostRaw(
    requestParameters: EnvironmentsMetadataPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling environmentsMetadataPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/environments/metadata`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['request']!.map(
          ApitypesUpsertEnvironmentsMetadataRequestToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Upsert environments metadata records
   * Upsert environments metadata
   */
  async environmentsMetadataPost(
    requestParameters: EnvironmentsMetadataPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.environmentsMetadataPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Upsert costs for multiple environments and cloud services
   * Upsert environment costs
   */
  async environmentsPostRaw(
    requestParameters: EnvironmentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling environmentsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/environments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['request']!.map(
          ApitypesUpsertEnvironmentsCostsRequestToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Upsert costs for multiple environments and cloud services
   * Upsert environment costs
   */
  async environmentsPost(
    requestParameters: EnvironmentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.environmentsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get summarised cloud costs of environments.
   * Get summary of environments costs
   */
  async environmentsSummaryGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApitypesEnvironmentsCostsSummaryResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/environments/summary`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ApitypesEnvironmentsCostsSummaryResponseFromJSON(jsonValue),
    );
  }

  /**
   * Get summarised cloud costs of environments.
   * Get summary of environments costs
   */
  async environmentsSummaryGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApitypesEnvironmentsCostsSummaryResponse> {
    const response = await this.environmentsSummaryGetRaw(initOverrides);
    return await response.value();
  }
}
